import { Component, OnInit, ViewChild } from '@angular/core';
import { Zona } from '../../_models/zona';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ZonaHistorico } from '../../_models/zona-historico';
import { ZonaHistoricoBarrio } from '../../_models/zona-historico-barrio';
import { ZonaHistoricoIntervencion } from '../../_models/ZonaHistoricoIntervencion';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { ZonaBarrioService } from '../../_services/zona-barrio.service';
import { ZonaService } from '../../_services/zona.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { of } from 'rxjs';
import { log } from 'util';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TerceroZona } from '../../_models/tercero-zona';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { ConstanteService } from '../../_services/constante.service';
import { ZonasLiberaciones } from '../../_models/zonas-liberaciones';
import { TerceroZonaService } from '../../_services/tercero-zona.service';
import { ZonaLiberacionService } from '../../_services/zona-liberacion.service';

@Component( {
  selector: 'app-zonas-listado',
  templateUrl: 'zonas-listado.component.html',
} )

export class ZonasListadoComponent implements OnInit {

  idEstructuraFisica: string;
  zones: Zona[] = [];
  busqueda: string;
  loadingZones = true;
  allZones: SelectItem[] = [];
  selectedZone: number;
  loadingData = false;
  historicZone: ZonaHistorico[] = [];
  historicNeighborhood: ZonaHistoricoBarrio[] = [];
  interventions: ZonaHistoricoIntervencion[] = [];
  @ViewChild('dt') tabla: Table;
  columnas: any[];
  menu: Funcionalidad = new Funcionalidad();
  seccion = 'L';
  zonSeleccionada: Zona = new Zona();

  mostrarDialogoCausal = false;
  carInformacionDialogoCausal = false;
  forCausalLiberacion: FormGroup;
  causalSubmitted = false;
  guaCausal = false;
  lisCausalLiberacion: SelectItem[] = [ { label: 'prueba 1', value: 1 }, { label: 'prueba 2', value: 2 }, { label: 'prueba 3', value: 3 } ];

  lisCausalesLiberacion: ListaItem[] = [];
  zonaLiberar: Zona = new Zona();
  validandoIndicador = false;

  constructor( private router: Router,
               private navService: NavService,
               private zonesBarriosServices: ZonaBarrioService,
               private autServicio: AutenticacionService,
               private route: ActivatedRoute,
               private zonesService: ZonaService,
               private conServicio: ConfirmationService,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private consService: ConstanteService,
               private terZonaService: TerceroZonaService,
               private zonLiberacionService: ZonaLiberacionService ) {

  }

  ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/zonas' );
    if ( mn ) {
      this.menu = mn;
    }

    if ( !this.menu.ver ) {
      this.router.navigate( [ '/sin-autorizacion' ] );
    }

    this.columnas = [
      { field: 'codifo', header: this.navService.buscarMensaje( 'ZONES.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navService.buscarMensaje( 'ZONES.LBL_ZONA' ), sort: true },
      { field: 'clasificacionZona', header: this.navService.buscarMensaje( 'ZONES.LBL_CLASIFICACION' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'ZONES.LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navService.getSearch( 'zones.component' );

    this.route.params.subscribe( ( params: Params ) => {
      this.idEstructuraFisica = params[ 'id' ];
      this.zonesService.listadoPorEstructuraFisicaHabilitadas( this.idEstructuraFisica ).subscribe( data => {
        this.zones = data;
        this.loadingZones = false;
        /*data.map( ( s: Zona ) => this.allZones.push( { label: s.codigo + ' - ' + s.zona, value: s.idZona } ) );*/
        this.tabla.filterGlobal( this.busqueda, 'contains' );
      } );
    } );

    this.carInformacionDialogoCausal = true;
    this.lisServicio.getMasterDetails( 'ListasCausalesLiberacion' ).subscribe( lisCausalesLiberacion => {

      lisCausalesLiberacion.map( ( s: ListaItem ) => {
        // this.lisCausalLiberacion.push( { label: s.nombre, value: s.idLista } );
        this.lisCausalesLiberacion.push( s );
      } );

      if ( this.lisCausalLiberacion.length === 0 ) {
        this.navService.setMesage( 4, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'LISTAS.MSG_NOEXISTE' )
        } );
      }

      this.carInformacionDialogoCausal = false;

    }, error => {
      this.navService.setMesage( 4, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'LISTAS.MSG_NOEXISTE' )
      } );
      this.carInformacionDialogoCausal = false;
    } );

    this.forCausalLiberacion = this.fb.group( {
      zona: [ null ],
      idCausalLiberacion: [ null, [ Validators.required ] ],
      observacion: [ null, [ Validators.required, Validators.maxLength( 500 ) ] ]
    } );

  }

  setSearch() {
    this.navService.setSearch( 'zones.component', this.busqueda );
  }

  crearZona() {
    this.zonSeleccionada = new Zona();
    this.seccion = 'C';
    // this.router.navigate( [ 'apl/zonas/agregar/' ] );
  }

  verZona( f: Zona ) {
    this.zonSeleccionada = Object.assign( {}, f );
    this.seccion = 'V';
    // this.router.navigate( [ 'apl/zonas/detalle/' + f.idZona ] );
  }

  editarZona( f: Zona ) {
    this.validandoIndicador = true;
    /*this.zonesService.get( f.idZona ).subscribe( ( response ) => {
      if ( response.indicadorDescargado !== null && response.indicadorDescargado === true ) {
        this.navService.setMesage( 0,
          {
            severity: 'info',
            summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
            detail: this.navService.buscarMensaje( 'ZONES.MSG_ERROREDITARZONA' )
          } );
        this.validandoIndicador = false;
      } else {*/
        this.validandoIndicador = false;
        this.zonSeleccionada = Object.assign( {}, f );
        this.seccion = 'E';
      //}
    // } );
    // this.router.navigate( [ 'apl/zonas/actualizar/' + f.idZona ] );
  }

  onChangeZones( selectedZone: string ) {
    if ( selectedZone !== undefined && selectedZone != null && selectedZone != '' ) {

      this.loadingData = true;
      // Consultar  listado de acciones (mas común)
      this.zonesService.getHistoryByZone( selectedZone ).subscribe( historicZone => {
        this.historicZone = historicZone;

        // Consultar listado de accionesBArrios (es posible que en un día solo actualicen barrios y no la zona...)
        this.zonesBarriosServices.getHistoryByZone( selectedZone ).subscribe( historicNeighborhood => {
          this.historicNeighborhood = historicNeighborhood;

          // Construir el listado base de intervenciones
          const basicInterventions: ZonaHistoricoIntervencion[] = [];

          // Extraer el total de usuarios con fecha del listado de acciones (Diferentes a los ya agregados user+day)
          this.historicZone.map( ( hz: ZonaHistorico ) => {

            const allReady = basicInterventions.find(
              ( bi: ZonaHistoricoIntervencion ) => ( bi.idUsuario === hz.idUsuario &&
                ( new Date( bi.fecha ) ).toDateString() === ( new Date( hz.fecha ) ).toDateString() ) );
            if ( allReady === undefined ) {
              const bi: ZonaHistoricoIntervencion = new ZonaHistoricoIntervencion();
              bi.fecha = hz.fecha;
              bi.usuario = hz.primerNombre + ' ' + hz.segundoNombre + ' ' + hz.primerApellido + ' ' + hz.segundoApellido;
              bi.idUsuario = hz.idUsuario;
              basicInterventions.push( bi );
            }

          } );

          // Extraer todos los usuarios de AccionesBarrios (Diferentes a los ya agregados user+day)
          this.historicNeighborhood.map( ( hnh: ZonaHistoricoBarrio ) => {

            const allReady = basicInterventions.find(
              ( bi: ZonaHistoricoIntervencion ) => ( bi.idUsuario === hnh.usuario &&
                ( new Date( bi.fecha ) ).toDateString() === ( new Date( hnh.fecha ) ).toDateString() ) );
            if ( allReady === undefined ) {
              const bi: ZonaHistoricoIntervencion = new ZonaHistoricoIntervencion();
              bi.fecha = hnh.fecha;
              bi.usuario = hnh.nombre;
              bi.idUsuario = hnh.usuario;
              basicInterventions.push( bi );
            }

          } );

          // Ordenar las intervenciones base
          // PENDIENTE

          // Iterar las intervenciones base
          //    Buscar todas las acciones por usuario y día agregando al array de acciones de la intervencion
          //       ordenar por hora
          //    Buscar todos los traslados usuario y día agregando al array de traslados  de la intervencion
          //       ordenar por hora

          basicInterventions.map( bi => {
            bi.acciones = this.historicZone.filter( ( hz: ZonaHistorico ) => ( bi.idUsuario === hz.idUsuario &&
              ( new Date( bi.fecha ) ).toDateString() === ( new Date( hz.fecha ) ).toDateString() ) );
            bi.barrios = this.historicNeighborhood.filter( ( hnh: ZonaHistoricoBarrio ) => ( bi.idUsuario === hnh.usuario &&
              ( new Date( bi.fecha ) ).toDateString() === ( new Date( hnh.fecha ) ).toDateString() ) );

            bi.barrios.sort( function( a: ZonaHistoricoBarrio, b: ZonaHistoricoBarrio ) {
              if ( a.fecha < b.fecha ) {
                return -1;
              } else {
                return 1;
              }
            } );
          } );

          this.interventions = basicInterventions;

          this.loadingData = false;
        } );
      } );

    }
  }

  cambiosComponentes( event: boolean ) {
    this.seccion = 'L';
    if ( event ) {
      this.loadingZones = true;
      this.zonesService.listadoPorEstructuraFisicaHabilitadas( this.idEstructuraFisica ).subscribe( data => {
        this.zones = data;
        this.loadingZones = false;
      } );
    }
  }

  mensajeError( label: string ) {
    this.navService.setMesage( 0,
      {
        severity: 'info',
        summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( label )
      } );
  }

  /**
   * Liberar la zona bloqueada en caso que no se pueda liberar mediante el celular
   * Params:
   * row = registro que contiene los datos de la zona a liberar.
   * */
  liberarZona( row: Zona ) {
    this.zonaLiberar = row;
    // Validar el nivel de rol de la persona logueada
    // si pasa la validacion debe abrir una ventana para confirmar la accion
    // si se confirma la accion, debe abrir una ventana para escoger el causal de liberacion de zona
    // enviar la solicitud al servidor para actualizar el indicado de edicion de la zona

    this.forCausalLiberacion = this.fb.group( {
      zona: [ row ],
      idCausalLiberacion: [ null, [ Validators.required ] ],
      observacion: [ null, [ Validators.required, Validators.maxLength( 500 ) ] ]
    } );

    const nivelUsuario = this.autServicio.obtenerNivelMaximo();
    const mensaje = '¿Está seguro que desea liberar la zona ' + row.nombre + '?';
    if ( nivelUsuario > 2 ) {
      this.conServicio.confirm( {
        message: this.navService.buscarMensaje( 'ZONES.MSG_LIBERARZONA' ),
        header: this.navService.buscarMensaje( 'ZONES.LBL_LIBERARZONA' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.mostrarDialogoCausal = true;
        },
        reject: () => {
          this.mostrarDialogoCausal = false;
          this.zonaLiberar = new Zona();
        }
      } );
    } else {
      this.zonaLiberar = new Zona();
      this.navService.setMesage( 0,
        {
          severity: 'info',
          summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'ZONES.MSG_PERMISOINFERIORLIBERAR' )
        } );
    }
  }

  cancelarLiberacion( dirty: boolean ) {
    this.causalSubmitted = false;
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.mostrarDialogoCausal = false;
          this.zonaLiberar = new Zona();
        },
        reject: () => {
        }
      } );
    } else {
      this.mostrarDialogoCausal = false;
      this.zonaLiberar = new Zona();
    }
  }

  liberacionZona() {
    this.causalSubmitted = true;
    if ( this.forCausalLiberacion.valid ) {
      this.conServicio.confirm( {
        message: this.navService.buscarMensaje( 'MSG_SEGUROGUARDAR' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.guaCausal = true;
          this.zonaLiberar.indicadorDescargado = false;
          this.zonesService.update( this.zonaLiberar ).subscribe( res => {
            this.cambiarIndicadorEdicionZona( this.zonaLiberar.idZona );
            this.guardarZonaLiberacion( this.forCausalLiberacion.value );
          }, error => {
            // 1 = Add, 2 = Update, 3 Error, 4 Custom
            this.navService.setMesage( 3 );
            this.guaCausal = false;
            this.zonaLiberar = new Zona();
            this.mostrarDialogoCausal = false;
            this.causalSubmitted = false;
          } );
        },
        reject: () => {
          this.guaCausal = false;
          this.mostrarDialogoCausal = false;
          this.zonaLiberar = new Zona();
          this.causalSubmitted = false;
        }
      } );
    } else {
      this.guaCausal = false;
    }
  }

  enviarCorreo( codigoLiberacion: string ) {
    // validar el codigo de la liberacion
    // validar la constante CORZON
    if ( codigoLiberacion.toLowerCase() == 'robop' ) {
      this.consService.getByCode( 'CORZON' ).subscribe( x => {
        if ( x && x.indicadorHabilitado ) {
          // this.zonesService.enviarCorreoLiberacion({});
          this.guaCausal = false;
          this.zonaLiberar = new Zona();
          this.mostrarDialogoCausal = false;
          this.navService.setMesage( 0,
            {
              severity: 'success',
              summary: this.navService.buscarMensaje( 'ZONES.LBL_CORREOLIBERACIONENVIADO' ),
              detail: this.navService.buscarMensaje( 'ZONES.MSG_CORREOLIBERACIONENVIADO' ),
            } );
        } else {
          this.guaCausal = false;
          this.zonaLiberar = new Zona();
          this.mostrarDialogoCausal = false;
          this.navService.setMesage( 0,
            {
              severity: 'success',
              summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
              detail: this.navService.buscarMensaje( 'ZONES.MSG_CORREOLIBERACIONNOENVIADO' ),
            } );
        }
      } );
    } else {
      this.guaCausal = false;
      this.navService.setMesage( 1 );
      this.zonaLiberar = new Zona();
      this.mostrarDialogoCausal = false;
    }
  }

  cambiarIndicadorEdicionZona( idZona: string ) {
    const zonaIndex = this.zones.findIndex( x => x.idZona == idZona );
    if ( zonaIndex > -1 ) {
      this.zones[ zonaIndex ].indicadorDescargado = false;
    }
  }

  guardarZonaLiberacion( zonaInfo: any ) {
    const liberacionZona: ZonasLiberaciones = new ZonasLiberaciones();
    liberacionZona.idZona = zonaInfo.zona.idZona;
    liberacionZona.idCausalLiberacion = zonaInfo.idCausalLiberacion.idLista;
    liberacionZona.observacion = zonaInfo.observacion;
    this.terZonaService.obtenerDatoEjecutivo( zonaInfo.zona.idZona ).subscribe( response => {
      liberacionZona.idEjecutivo = response.tercero.idTercero;
      this.zonLiberacionService.liberarZona( liberacionZona ).subscribe( res => {
        this.causalSubmitted = false;
        this.enviarCorreo( this.forCausalLiberacion.value.idCausalLiberacion.codigo );
      } );
    } );
  }

}
